import {Component, inject} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatDialog, MatDialogModule} from '@angular/material/dialog';
import {AuthenticationConfigurationService} from '@modules/authentication/core/config/authentication-configuration.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {ModalPageComponent} from 'fuse-core/components/basic-page/modal-page/modal-page.component';

@Component({
    selector: 'app-gar-login',
    imports: [
        TranslateModule,
        MatDialogModule,
        MatButtonModule
    ],
    templateUrl: './gar-login.component.html',
    styleUrl: './gar-login.component.scss'
})
export class GarLoginComponent {
    private translate = inject(TranslateService);
    private dialog = inject(MatDialog);
    private config = inject(AuthenticationConfigurationService);

    public enableGAR = this.config.settings?.enableGAR;
    public displayGARHelper = this.config.settings?.displayGARHelper;
    public entButtonAllowed = this.config.settings?.entButtonAllowedWithoutRules;

    public onDisplayENTHelpClick(): void {
        if (this.config.settings?.useUrlGarRegister) {
            window.open(this.config.settings.urlGarRegister, '_blank');
        } else {
            this.translate.get('cookie.dismiss').subscribe((translation: string) => {
                this.dialog.open(ModalPageComponent, {
                    panelClass: 'entity-form-dialog',
                    data: {alias: 'me-connecter-ent', labelConfirmDialog: translation},
                });
            });
        }
    }
}
